import { Link2Off } from 'lucide-react';
import { ROUTES } from '@/lib/constants/routes';
import { UI_STRINGS } from '@/lib/constants/ui-strings';
import { LinkStatusCard } from '@/components/common/LinkStatusCard';

/**
 * "This Link Is No Longer Active" - the Shared Startup Profile link-expired
 * screen (MYN-58 screen 1). Composes the shared `LinkStatusCard` (promoted
 * from `InviteExpiredState`). Unlike the invite-expired flow, the design
 * shows one identical message for expired, revoked, and not-found alike -
 * no status pills distinguishing them.
 *
 * `fullScreen` because this notice IS the page in both places it renders:
 * under `SharedProfileLayout` (viewport minus the public header) from the gate
 * screens, and with no layout at all from `/p/:token/view`. The offset it
 * subtracts is inherited from whichever of those is above it.
 */
export function SharedProfileExpiredState() {
  const S = UI_STRINGS.SHARED_PROFILE;
  return (
    <LinkStatusCard
      icon={<Link2Off size={32} />}
      heading={S.EXPIRED_HEADING}
      body={S.EXPIRED_BODY}
      ctaLabel={S.EXPIRED_CTA}
      ctaTo={ROUTES.HOME}
      footnote={S.EXPIRED_FOOTNOTE}
      fullScreen
    />
  );
}
